export function getPDDomain() {
  const host = window.location.hostname;
  const local = /localhost/.test(host);
  const pdStaging = /pd-staging.com/.test(host);
  const sandbox = /sandbox.wpengine.com/.test(host);
  const staging = /staging.wpengine.com/.test(host);

  if (local) {
    return ".pagerduty.localhost";
  } else if (pdStaging) {
    return ".pd-staging.com";
  } else if (staging || sandbox) {
    return host;
  }
  return ".pagerduty.com";
}
